import { application } from "./application"

import RecaptchaController from "./recaptcha_controller"
application.register("recaptcha", RecaptchaController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import DeviceIdController from "./device_id_controller"
application.register("device-id", DeviceIdController)


import LocaleSwitchController from "./locale_switch_controller"
application.register("locale-switch", LocaleSwitchController)

import ReviewRemindController from "./review_remind_controller"
application.register("review-remind", ReviewRemindController)

import CategoryTabsController from "./category_tabs_controller"
application.register("category-tabs", CategoryTabsController)

import VariantsFormController from "./variants_form_controller"
application.register("variants-form", VariantsFormController)

import OcrUploadController from "./ocr_upload_controller"
application.register("ocr-upload", OcrUploadController)

import OcrConfirmController from "./ocr_confirm_controller"
application.register("ocr-confirm", OcrConfirmController)

import OcrVariantsController from "./ocr_variants_controller"
application.register("ocr-variants", OcrVariantsController)

import MenuListController from "./menu_list_controller"
application.register("menu-list", MenuListController)

import MenuSearchController from "./menu_search_controller"
application.register("menu-search", MenuSearchController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import MenuMoveController from "./menu_move_controller"
application.register("menu-move", MenuMoveController)

import AdminSidebarController from "./admin_sidebar_controller"
application.register("admin-sidebar", AdminSidebarController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import ScrollHeaderController from "./scroll_header_controller"
application.register("scroll-header", ScrollHeaderController)

import ItemModalController from "./item_modal_controller"
application.register("item-modal", ItemModalController)

import AiChatController from "./ai_chat_controller"
application.register("ai-chat", AiChatController)

import ReviewSubmitController from "./review_submit_controller"
application.register("review-submit", ReviewSubmitController)

import ChatMenuController from "./chat_menu_controller"
application.register("chat-menu", ChatMenuController)

import ChatAutosaveController from "./chat_autosave_controller"
application.register("chat-autosave", ChatAutosaveController)

import ChatItemPhotoController from "./chat_item_photo_controller"
application.register("chat-item-photo", ChatItemPhotoController)

import ImagePreviewController from "./image_preview_controller"
application.register("image-preview", ImagePreviewController)

import CropperController from "./cropper_controller"
application.register("cropper", CropperController)

import RequiredFormController from "./required_form_controller"
application.register("required-form", RequiredFormController)

import ScrollToController from "./scroll_to_controller"
application.register("scroll-to", ScrollToController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import LegalModalController from "./legal_modal_controller"
application.register("legal-modal", LegalModalController)

import PasswordToggleController from "./password_toggle_controller"
application.register("password-toggle", PasswordToggleController)

import DismissBannerController from "./dismiss_banner_controller"
application.register("dismiss-banner", DismissBannerController)

import BillingToggleController from "./billing_toggle_controller"
application.register("billing-toggle", BillingToggleController)

import AccordionController from "./accordion_controller"
application.register("accordion", AccordionController)

import ScrollRevealController from "./scroll_reveal_controller"
application.register("scroll-reveal", ScrollRevealController)

import ProgressBarController from "./progress_bar_controller"
application.register("progress-bar", ProgressBarController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CancelConfirmController from "./cancel_confirm_controller"
application.register("cancel-confirm", CancelConfirmController)

import QrDownloadController from "./qr_download_controller"
application.register("qr-download", QrDownloadController)

import ShopConfirmController from "./shop_confirm_controller"
application.register("shop-confirm", ShopConfirmController)

import BulkTranslationController from "./bulk_translation_controller"
application.register("bulk-translation", BulkTranslationController)

import MagicLinkController from "./magic_link_controller"
application.register("magic-link", MagicLinkController)

import TrashModalController from "./trash_modal_controller"
application.register("trash-modal", TrashModalController)

import UndoToastController from "./undo_toast_controller"
application.register("undo-toast", UndoToastController)
